import { Field, TextOutput } from 'Components/Core';
import { WorksheetAssociatedTestSection } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';
import { NamePrefixModifier, withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { ListFieldSection, PageSection } from '../../../../../Layout';

let WashingPageSection: React.FC<IWorksheetComponent> = () => {
  return (
    <PageSection heading="Washing">
      <WorksheetAssociatedTestSection
        testType="Wash"
        associatedTestModel={{
          measured: true,
        }}
        name="Washing.AssociatedWashTest"
        indented={false}
      />

      {/* Percentage passing washing sieve on a whole portion basis */}
      <ListFieldSection>
        <NamePrefixModifier namePrefix="data.Results">
          <Field input={<TextOutput />} name="PercentagePassingWashingSieve" />
        </NamePrefixModifier>
      </ListFieldSection>
    </PageSection>
  );
};

WashingPageSection = withInjectedProps(WashingPageSection);

export { WashingPageSection };
export default WashingPageSection;
